import type { FaireProductEntity } from "../../entity_types/product";

export const p_51t1viwh82: FaireProductEntity = {
  token: "p_51t1viwh82",
  type: "product",
  name: "Alentejo — Regenerative Organic Certified",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/f28cb92d087ca7cb054149429c031256eded0633331451a2774ded1e9f0207b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9094b4c3f9fdee7f3c50a33f0961c6ef2c02978f4472a3c0d591bf2ad3ed9395.jpeg",
    "https://cdn.faire.com/fastly/fc0186f7fca94cb60c4b4baab119d5a0a41b437aad2385850daf0694c471236c.jpeg",
    "https://cdn.faire.com/fastly/9e5336a21ad299fb4c69396b2cdcb353474c7c121db3f9f91932247e3c6150cd.jpeg",
  ],
  priceDollars: 12.1,
  description:
    "Our darkest roast, The Alentejo was developed as an ode to classic European-style espresso that had been crafted with intention over generations. Inspired by our travels, available year-round.\n\n𝐀𝐛𝐨𝐮𝐭 𝐀𝐥𝐞𝐧𝐭𝐞𝐣𝐨\n• Origin: Mexico\n• Region: San Agustín Loxicha, indigenous Zapotec community in the state of Oaxaca\n• Producer: UNECAFE S.C\n• Process: Washed\n• Certification: Organic, Regenerative Organic Certified\n• We Taste: Caramel, milk chocolate, & orange peel\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞\nThe cultivation of coffee in this area, and especially for Tierra Blanca, is an agricultural resource with great importance beyond agricultural business. In the region, coffee growing helps maintain a diverse ecosystem by providing a reservoir for rainwater, giving life to the local flora and fauna.\n\nThe unique altitude and climate of the Mexican Pacific enhances the quality of the coffee grown in the region, furthering its delicious natural flavor and aroma. Coffees from this region are referred to as having a “Pluma” coffee profile.",
  tags: [],
  msrpDollars: 24.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:09.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
